<template>
  <div>
    <router-view></router-view>
    <ModalContainer>
      <template #overlay>
        <div :class="$style.modalOverlay"></div>
      </template>
    </ModalContainer>
    <SnackContainer :class="$style.snackContainer" />
  </div>
</template>

<script setup lang="ts">
import { ModalContainer, SnackContainer } from "vue-haystack";
</script>

<style lang="scss" module>
.modalOverlay {
  width: 100%;
  height: 100%;
  background-color: #1c1c1c;
  opacity: 0.5;
}

.snackContainer {
  top: calc(var(--app-header-height) + #{map-get($map: $spacers, $key: s)});
  right: #{map-get($map: $spacers, $key: s)};
}
</style>
